<template>
    <div class="col-xs-12 col-sm-12 col-md-12">
        <div class="row" v-if="member">
            <div class="col-sm-6 col-md-4 pt-2 pb-2">
                <div>{{member.firstName}} {{member.lastName}}</div>
                <div v-if="member.address !== ''">{{member.address}}<br></div>
                <div v-if="member.address2 !== ''">{{member.address2}}<br></div>
                <div v-if="member.city">{{member.city}}, {{member.stateName}} {{member.zipCode}}</div>
                <br>
                <span v-if="member.cert">
                        <font-awesome-icon icon="address-card"></font-awesome-icon> {{member.cert}}<br>
                </span>
                <span v-if="member.homePhone">
                        <font-awesome-icon icon="phone"></font-awesome-icon> {{member.homePhone | phone}}<br>
                    </span>
                <span v-if="member.workPhone">
                        <font-awesome-icon icon="building"></font-awesome-icon>{{member.workPhone | phone}}<br>
                    </span>
                <span v-if="member.dhmoId">
                        <font-awesome-icon icon="notes-medical"></font-awesome-icon> {{member.dhmoId}}<br>
                </span>
                <br>
                <b-button :to="'/dashboard/member/' + member.cert + '/address'">Change Contact Info</b-button>

            </div>
            <div class="col-sm-4 col-md-3 pt-2 pb-2" v-if="member.plans">
                <b-list-group>
                    <b-list-group-item v-for="plan in member.plans" :key="plan.plan_code"
                                       class="flex-column align-items-start">
                        <div class="d-flex justify-content-between">
                            <h5 class="mb-1">
                                <font-awesome-icon :icon="plan.icon"></font-awesome-icon>
                                {{plan.description}}
                            </h5>
                        </div>
                    </b-list-group-item>
                </b-list-group>
                <br>
                <div v-if="member.products">
                    <b-list-group>
                        <b-list-group-item v-for="product in member.products" :key="product.plan_code"
                                           class="flex-column align-items-start">
                            <div class="d-flex justify-content-between">
                                <h5 class="mb-1">
                                    <font-awesome-icon :icon="product.icon"></font-awesome-icon>
                                    {{product.description}}
                                </h5>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </div>
            <div class="col-sm-4 col-md-5 pt-2 pb-2" v-if="member.dependents">
                <dependent-list :dependents="member.dependents"></dependent-list>
                <br>
                <b-button class="float-right" :to="'/dashboard/member/' + member.cert + '/dependents'">Change
                    Dependents
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import DependentList from './DependentList'

    export default {
        name: 'MemberCard',
        components: {DependentList},
        props: ['member']
    }
</script>


<style scoped>
    .well {
        background: #F5F5F5
    }

    .glyphicon {
        margin-bottom: 10px;
        margin-right: 10px;
    }

    small {
        display: block;
        line-height: 1.428571429;
        color: #999;
    }
</style>
